import { Link, useLocation } from 'react-router-dom';
import { UserMenu } from './UserMenu';

interface LayoutProps {
  children: React.ReactNode;
}

const NAV_ITEMS = [
  { path: '/eval-sets', label: 'Eval Sets' },
  { path: '/samples', label: 'Samples' },
  { path: '/scans', label: 'Scans' },
];

export function Layout({ children }: LayoutProps) {
  const location = useLocation();

  return (
    <div className="h-screen flex flex-col overflow-hidden bg-gray-50">
      {/* Top Navigation Header */}
      <header
        className="shrink-0 px-5 py-2.5 shadow-sm"
        style={{
          background: 'linear-gradient(135deg, #1a4a2e 0%, #1f5a38 100%)',
        }}
      >
        <nav className="flex items-center justify-between">
          <div className="flex items-center gap-1">
            {NAV_ITEMS.map(item => {
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className="px-4 py-2 text-sm font-medium rounded-md transition-all duration-150"
                  style={{
                    backgroundColor: isActive
                      ? 'rgba(255,255,255,0.2)'
                      : 'transparent',
                    color: isActive ? '#ffffff' : 'rgba(255,255,255,0.7)',
                    textDecoration: 'none',
                    boxShadow: isActive ? '0 1px 2px rgba(0,0,0,0.1)' : 'none',
                  }}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
          <UserMenu />
        </nav>
      </header>

      {/* Main Content */}
      <main className="flex-1 overflow-hidden bg-white">{children}</main>
    </div>
  );
}
